<template>
  <div :class="{
    'flash-success-message': messages.length > 0 && !inSnackbar,
    'flash-error-message': errors.length > 0 && !inSnackbar,
    'flash-success-message-in-snackbar': messages.length > 0 && inSnackbar,
    'flash-error-message-in-snackbar': errors.length > 0 && inSnackbar
  }" v-if="messages.length > 0 || errors.length > 0">
    <strong v-for="(message, index) in messages" :key="'flash-success-' + index" v-html="message"><br></strong>
    <strong v-for="(error, index) in errors" :key="'flash-error-' + index" v-html="error"><br></strong>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    props: {
      errors    : {
        type   : Array,
        default: function () {
          return [];
        }
      },
      messages  : {
        type   : Array,
        default: function () {
          return [];
        }
      },
      inSnackbar: {
        type   : Boolean,
        default: function () {
          return false;
        }
      }
    },
  }
</script>

<style lang="scss">
  .flash-success-message {
    background-color: #ccffcc;
    border: 1px solid #5cb85c;
    padding: 20px 20px;
    color: #5cb85c;
  }

  .flash-success-message-in-snackbar {
    background-color: transparent;
    color: #5cb85c;
  }

  .flash-error-message {
    background-color: #ffcccc;
    border: 1px solid #d9534f;
    padding: 20px 20px;
    color: #d9534f;
  }

  .flash-error-message-in-snackbar {
    background-color: transparent;
    color: #d9635f;
  }
</style>
